import React, { useState } from 'react';
import { Navbar, NavbarToggler, Collapse, Nav, NavItem } from 'reactstrap';
import './styles.scss';
import LoginModal from './LoginModal';
import { Link, useLocation } from 'react-router-dom';
import classnames from 'classnames';

const MENU_ITEMS = [
  { to: '/', label: 'Home' },
  { to: '/retailers', label: 'Retailers / Suppliers' },
  { to: '/management', label: 'Management / Pricing' },
  { to: '/work-orders', label: 'Work Orders / Services' },
  { to: '/register', label: 'Register / Contact' },
];

const Menu: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggle = () => setIsOpen(!isOpen);

  // One DOM order, two layouts. Mobile keeps it as written -- lockup and
  // toggler share the first line, the collapse drops below. Desktop reorders
  // via CSS so the menu takes the first line and the lockup the second.
  // The lockup already renders "WORLD GEM TRADE" and the tagline, so no text
  // sibling duplicates them.
  return (
    <header className="site-header">
      <Navbar light expand="lg" color="white">
        <div className="container-md container-lg container-xl container-xxl navbar-inner">
          <Link to="/" className="brand-lockup">
            <img
              src="/images/wgt-brand-lockup.png"
              alt="World Gem Trade - Trace for a better world"
              className="brand-lockup-img"
            />
          </Link>
          <NavbarToggler onClick={toggle} />
          <Collapse isOpen={isOpen} navbar>
            <Nav className="site-nav" navbar>
              {MENU_ITEMS.map((menu, key) => (
                <NavItem key={`menu-${key}`}>
                  <Link
                    to={menu.to}
                    className={classnames('nav-link', {
                      active: location?.pathname === menu.to,
                    })}
                  >
                    {menu.label}
                  </Link>
                </NavItem>
              ))}
            </Nav>

            <LoginModal />
          </Collapse>
        </div>
      </Navbar>
    </header>
  );
};

export default Menu;
